/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WorkScheduleRecord } from './WorkScheduleRecord';
import {
    WorkScheduleRecordFromJSON,
    WorkScheduleRecordFromJSONTyped,
    WorkScheduleRecordToJSON,
} from './WorkScheduleRecord';

/**
 * 
 * @export
 * @interface WorkScheduleWrapper
 */
export interface WorkScheduleWrapper {
    /**
     * 
     * @type {Array<WorkScheduleRecord>}
     * @memberof WorkScheduleWrapper
     */
    data?: Array<WorkScheduleRecord> | null;
}

/**
 * Check if a given object implements the WorkScheduleWrapper interface.
 */
export function instanceOfWorkScheduleWrapper(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WorkScheduleWrapperFromJSON(json: any): WorkScheduleWrapper {
    return WorkScheduleWrapperFromJSONTyped(json, false);
}

export function WorkScheduleWrapperFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkScheduleWrapper {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : (json['data'] === null ? null : (json['data'] as Array<any>).map(WorkScheduleRecordFromJSON)),
    };
}

export function WorkScheduleWrapperToJSON(value?: WorkScheduleWrapper | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : (value.data === null ? null : (value.data as Array<any>).map(WorkScheduleRecordToJSON)),
    };
}

